const getters = {
  isLoggedIn: (state) => {
    return !!state.currentUser;
  }
};

export default getters;
